<template>
  <div class="container layoutShell">
    <el-container class="layoutContainer">
      <div
        ref="asideSlot"
        class="layoutAsideSlot"
        :class="{
          'is-pinned': !isCollapse,
          'is-expanded': !isCollapse || sidebarPeek,
          'is-floating': sidebarFloating,
        }"
        @mouseenter="onSidebarEnter"
        @mouseleave="onSidebarLeave"
        @focusin="onSidebarFocusIn"
        @focusout="onSidebarFocusOut"
      >
        <el-aside class="aside layoutAside" style="width: auto">
          <silder
            :list="menuList"
            :collapsed="isCollapse && !sidebarPeek"
            @navigate="closeSidebarPeek"
            @toggle-pin="setSidebarPinned(isCollapse)"
          ></silder>
        </el-aside>
      </div>
      <el-container>
        <el-header class="header layoutHeader" :class="{ 'layoutHeader--linkModule': isLinkManageLayout }">
          <div class="headerBread">
            <div class="headerBread__leading">
              <!-- 子页（查看/编辑/创建等）用返回列表替代侧边栏折叠 -->
              <button
                v-if="layoutBackTo"
                type="button"
                class="layoutBackLink"
                @click="goLayoutBack"
              >
                <i class="el-icon-arrow-left" aria-hidden="true" />
                {{ layoutBackLabel }}
              </button>
              <template v-else>
                <i
                  v-show="!isCollapse"
                  class="el-icon-s-fold menuButton"
                  title="取消固定侧栏"
                  @click="setSidebarPinned(false)"
                ></i>
                <i
                  v-show="isCollapse"
                  class="el-icon-s-unfold menuButton"
                  title="固定侧栏"
                  @click="setSidebarPinned(true)"
                ></i>
              </template>
            </div>
            <breadTitle :breadCrumbList="breadCrumbList"></breadTitle>
            <!-- <a
              style="text-decoration: none; color: #333"
              href="http://baidu.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i
                class="questionIcon el-icon-question"
                data-content="帮助文档"
              ></i>
            </a> -->
          </div>
          <div class="headerActions">
            <layout-theme-picker />
            <el-dropdown>
            <div class="userInfo">
              <img
                class="avart"
                src="https://cdn.sticker-emojis.com/picture/fun_sticker_maker/Pop_Style_Word.png"
                alt="avart"
              />
              <div>{{ userName }}</div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-user-solid" @click.native="editPassword"
                >修改密码</el-dropdown-item
              >
              <el-dropdown-item icon="el-icon-user-solid" @click.native="logOut"
                >退出登录</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          </div>
        </el-header>
        <el-main class="layoutMain" :class="{ 'layoutMain--linkModule': isLinkManageLayout }">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      :before-close="closeDialog"
      style="padding: 0 50px"
      width="40%"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item prop="oldPassword" label="旧密码">
          <el-input
            :readonly="readonly"
            type="text"
            v-model="ruleForm.oldPassword"
            placeholder="输入旧密码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="newPassword" label="新密码">
          <el-input
            :readonly="readonly"
            type="password"
            v-model="ruleForm.newPassword"
            placeholder="输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="checkPass" label="确认密码">
          <el-input
            :readonly="readonly"
            type="password"
            v-model="ruleForm.checkPass"
            placeholder="确认密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="width: 80%" type="primary" @click="submitEditPassword"
          >提 交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 全局限壳 token / 侧栏 / 主题：从 JS 入口引入，避免无 scoped <style>@import 误导「像局部样式」
import "./resourceManage/genericResourceManage/linkListTheme.css";
// 上传弹层 / 文件上传工作台表面样式：多页共用 class，须全局挂载（此前仅写文件未 import，投放区会塌成左上角）
import "./resourceManage/genericResourceManage/linkUploadSurfaces.css";
import "./layoutSidebar.css";
import "./cmsGlobalTheme.css";
import silder from "../components/silder.vue";
import breadTitle from "../components/breadTitle.vue";
import LayoutThemePicker from "../themes/LayoutThemePicker.vue";
import { store, mutations } from "../utils/store";
import { updatePassword } from "../api/auth";
import { resolveLayoutBackTo } from "../utils/layoutNavigation";

const SIDEBAR_PEEK_OPEN_MS = 150;
const SIDEBAR_PEEK_CLOSE_MS = 300;

export default {
  name: "Layout",
  data() {
    return {
      dialogVisible: false,
      ruleForm: {},
      rules: {
        oldPassword: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
          { min: 8, max: 15, message: "密码长度应为8-15位", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 8, max: 15, message: "密码长度应为8-15位", trigger: "blur" },
        ],
        checkPass: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("请再次输入新密码"));
              } else if (value !== this.ruleForm.newPassword) {
                callback(new Error("两次输入的密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      readonly: true,
      /** 未固定时鼠标或键盘焦点进入侧栏：整栏浮在内容上方展开，不挤内容区 */
      sidebarPeek: false,
    };
  },
  components: {
    silder,
    breadTitle,
    LayoutThemePicker,
  },
  computed: {
    userName() {
      return this.$store.getters["user/getUserName"];
    },
    menuList() {
      var list = this.$router.options.routes[1].children;
      list.forEach((element, index) => {
        if (element.children !== undefined) {
          element.children.forEach((ele, ind) => {
            if (ele.children !== undefined) {
              let flag = ele.children.every((val) => val.hidden);
              if (flag) {
                ele.children = undefined;
              } else {
                ele.children.forEach((e, i) => {
                  if (e.children !== undefined) {
                    let flag = e.children.every((val) => val.hidden);
                    if (flag) {
                      e.children = undefined;
                    }
                  }
                });
              }
            }
          });
        }
      });
      return list;
    },
    isCollapse() {
      return store.isCollapse;
    },
    sidebarFloating() {
      return this.isCollapse && this.sidebarPeek;
    },
    breadTitle() {
      return store.breadTitle;
    },
    breadCrumbList() {
      var arr = [];
      this.$route.matched.some((e, i) => {
        var obj = { name: e.name, path: e.path, redirect: e.redirect };
        arr.push(obj);
      });
      var list = JSON.parse(JSON.stringify(arr));
      list.shift();
      list[list.length - 1].path = "";
      if (this.breadTitle) {
        list[list.length - 1].name = this.breadTitle;
      }

      return list;
    },
    /** 路由 meta.layoutBackTo / query.backTo 存在时，顶栏左侧显示「返回列表」而非折叠菜单 */
    layoutBackTo() {
      return resolveLayoutBackTo(this.$route, null);
    },
    layoutBackLabel() {
      const backTo = resolveLayoutBackTo(this.$route, null);
      if (backTo && String(backTo).includes("/collection/classify/resources")) {
        return "返回分类";
      }
      return (this.$route.meta && this.$route.meta.layoutBackLabel) || "返回列表";
    },
    /** 通用资源 / Ai 角色等同族模块：顶栏面包屑与 layoutMain 暖灰 canvas */
    isLinkManageLayout() {
      const path = String(this.$route.path || "")
      return path.startsWith("/resource/link") || path.startsWith("/resource/aiAssistant")
    },
  },
  watch: {
    $route() {
      this.closeSidebarPeek();
    },
  },
  beforeDestroy() {
    clearTimeout(this.sidebarPeekTimer);
  },
  methods: {
    /** 固定后常驻展开并挤开内容；切换时收起浮层，免得取消固定后还浮着 */
    setSidebarPinned(pinned) {
      mutations.setIsCollapse(!pinned);
      this.closeSidebarPeek();
    },
    // 进入稍等再浮出，鼠标只是划过不弹；离开稍等再收，出界一点不至于闪
    onSidebarEnter() {
      if (!this.isCollapse) return;
      clearTimeout(this.sidebarPeekTimer);
      this.sidebarPeekTimer = setTimeout(() => {
        this.sidebarPeek = true;
      }, SIDEBAR_PEEK_OPEN_MS);
    },
    onSidebarLeave() {
      clearTimeout(this.sidebarPeekTimer);
      if (!this.sidebarPeek) return;
      this.sidebarPeekTimer = setTimeout(() => {
        this.sidebarPeek = false;
      }, SIDEBAR_PEEK_CLOSE_MS);
    },
    onSidebarFocusIn() {
      if (!this.isCollapse) return;
      clearTimeout(this.sidebarPeekTimer);
      this.sidebarPeek = true;
    },
    onSidebarFocusOut(event) {
      if (!this.$refs.asideSlot.contains(event.relatedTarget)) {
        this.closeSidebarPeek();
      }
    },
    closeSidebarPeek() {
      clearTimeout(this.sidebarPeekTimer);
      this.sidebarPeek = false;
    },
    goLayoutBack() {
      if (this.layoutBackTo) {
        this.$router.push(this.layoutBackTo);
      }
    },
    logOut() {
      this.$store.commit("user/LOG_OUT");
      this.$router.push("/login");
      location.reload();
    },
    editPassword() {
      this.dialogVisible = true;
      setTimeout(() => {
        this.readonly = false;
      }, 1000);
    },
    submitEditPassword() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          updatePassword(this.ruleForm)
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "修改密码成功,请重新登录",
                });
                this.logOut();
              } else {
                this.$message({
                  type: "error",
                  message: res.errMessage,
                  duration: 5000,
                  showClose: true,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
                duration: 5000,
                showClose: true,
              });
            });
        } else {
          this.$message({
            type: "info",
            message: "您还有表单没填完整！",
          });
          return false;
        }
      });
    },
    closeDialog() {
      this.dialogVisible = false;
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>
<style scoped>
@import "./resourceManage/genericResourceManage/layoutLinkHeader.css";

.questionIcon {
  font-size: 15px;
  margin-left: 20px;
  cursor: pointer;
}
.questionIcon:hover::after {
  content: attr(data-content);
  width: auto;
  height: auto;
  font-size: 12px;
  margin-left: 5px;
  margin-top: 3px;
}
::v-deep .el-main {
  padding: 0;
}
.layoutContainer,
.container {
  height: 100%;
}
.dialog-footer {
  text-align: center;
  margin: 0 auto;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.menuButton {
  font-size: 20px;
  cursor: pointer;
}
.aside {
  height: 100%;
}
.headerBread {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
}

.headerBread__leading {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.layoutBackLink {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin: 0;
  padding: 6px 12px 6px 10px;
  border: 1px solid #e5dfd6;
  border-radius: 8px;
  background: #f3f0ea;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  color: #44403c;
  white-space: nowrap;
  cursor: pointer;
}

.layoutBackLink:hover {
  background: #ece6de;
  border-color: #d6d3d1;
  color: #292524;
}

.headerBread >>> .breadContainer {
  margin-left: 0;
  min-width: 0;
}

.headerActions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 4px;
}

.userInfo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.avart {
  width: 24px;
  height: 24px;
  border-radius: 12px;
  margin-right: 10px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}
</style>
